import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, InstagramIcon, MailIcon, MapPinIcon, MusicIcon, PhoneIcon, YoutubeIcon } from 'lucide-react';
import { CLUB, NAV } from '../data/site';
import { SCHEDULE } from '../data/practical';
const SOCIAL_ICONS = [{
  label: 'Facebook',
  href: 'https://facebook.com',
  Icon: FacebookIcon
}, {
  label: 'Instagram',
  href: 'https://instagram.com',
  Icon: InstagramIcon
}, {
  label: 'TikTok',
  href: 'https://tiktok.com',
  Icon: MusicIcon
}, {
  label: 'YouTube',
  href: 'https://youtube.com',
  Icon: YoutubeIcon
}];
export function Footer() {
  return <footer className="border-t border-gold/20 bg-ink" data-id="element-22" data-mp="3lf58gu5i3vnz">
      <div className="mx-auto max-w-shell px-5 py-14 lg:px-8" data-id="element-23" data-mp="3lggez1qbzhis">
        <p className="font-display text-2xl uppercase tracking-[0.1em] text-gold" data-id="element-24" data-mp="3qc40n75ltsjj">L’esprit du Zanshin</p>
        <div className="zk-rule mt-4" data-id="element-25" data-mp="29ydrvn3jig3k" />

        <div className="mt-10 grid gap-10 lg:grid-cols-[1.1fr_0.8fr_1.2fr]" data-id="element-26" data-mp="2ey9zrxfcyroe">
          <div data-id="element-27" data-mp="2ew700loelk6h">
            <h2 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-bone" data-id="element-28" data-mp="2evxbl2j0bl2w">Contact</h2>
            <address className="mt-5 space-y-4 not-italic text-sm text-muted" data-id="element-29" data-mp="3gapc1fucueee">
              <p className="flex gap-3" data-id="element-30" data-mp="3gctpopi22rrv">
                <MapPinIcon size={16} className="mt-0.5 shrink-0 text-gold" aria-hidden data-id="element-31" data-mp="3v7zwheoz6um9" />
                <span data-id="element-32" data-mp="3q83s3ecd9166">
                  <span className="block font-medium text-bone" data-id="element-33" data-mp="3q7u0xnfl4nyw">{CLUB.name}</span>
                  {CLUB.address.map(line => <span key={line} className="block" data-id="element-34" data-mp="80xi63gl8rgz">
                      {line}
                    </span>)}
                </span>
              </p>
              <p className="flex items-center gap-3" data-id="element-35" data-mp="hrihjt43600y">
                <PhoneIcon size={16} className="shrink-0 text-gold" aria-hidden data-id="element-36" data-mp="cu0gsq082r41" />
                <a className="zk-focus hover:text-bone" href={CLUB.phoneHref} data-id="element-37" data-mp="cw34v4htea64">
                  {CLUB.phone}
                </a>
              </p>
              <p className="flex items-center gap-3" data-id="element-38" data-mp="msy27k2cq4it">
                <MailIcon size={16} className="shrink-0 text-gold" aria-hidden data-id="element-39" data-mp="mq3jbwyzkrri" />
                <a className="zk-focus break-all hover:text-bone" href={`mailto:${CLUB.email}`} data-id="element-40" data-mp="tt088o5w6ipf">
                  {CLUB.email}
                </a>
              </p>
            </address>

            <ul className="mt-6 flex gap-3" data-id="element-41" data-mp="13rpoydm1xx43">
              {SOCIAL_ICONS.map(({
              label,
              href,
              Icon
            }) => <li key={label} data-id="element-42" data-mp="18lby3vt0biv5">
                  <a href={href} target="_blank" rel="noreferrer" aria-label={label} className="zk-focus inline-flex h-10 w-10 items-center justify-center border border-gold/30 text-gold transition-colors duration-150 ease-out hover:bg-gold hover:text-ink" data-id="element-43" data-mp="1clunzkbcaeup">
                    <Icon size={18} aria-hidden data-id="element-44" data-mp="1rgisow8x1999" />
                  </a>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col items-center text-center" data-id="element-45" data-mp="3t9gei849z1kp">
            <h2 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-bone" data-id="element-46" data-mp="2af3qtkngqtgz">Notre identité</h2>
            <img src={CLUB.logo} alt="Logo du Zanshin Karaté Club" className="mt-5 h-36 w-36 rounded-full" data-id="element-47" data-mp="25nvikrxvde5e" />
            <p className="mt-4 max-w-[16rem] text-xs leading-relaxed text-muted" data-id="element-48" data-mp="21m0itrvl78tq">
              Le samouraï, les cornes de cerf et le katana : les sept valeurs du Bushido transmises sur le tatami.
            </p>
          </div>

          <div data-id="element-49" data-mp="2tdg2pe5rehg9">
            <h2 className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-bone" data-id="element-50" data-mp="2tbvjgkowakxp">
              Horaires & affiliation
            </h2>
            <div className="mt-5 flex flex-col gap-6 sm:flex-row sm:justify-between" data-id="element-51" data-mp="2kci79k9dzi9a">
              <dl className="space-y-3 text-sm" data-id="element-52" data-mp="2feq6e0qrklsy">
                {SCHEDULE.map(session => <div key={session.day} data-id="element-53" data-mp="18ynvhfhlqwzd">
                    <dt className="font-display uppercase tracking-[0.12em] text-crimson" data-id="element-54" data-mp="18zpi8h7zd7wx">{session.day}</dt>
                    <dd className="mt-1 space-y-0.5 text-muted" data-id="element-55" data-mp="13xqf98g5kd0i">
                      {session.slots.map(slot => <span key={slot.group} className="block" data-id="element-56" data-mp="2rtwkhv4gim8m">
                          {slot.group} · {slot.time}
                        </span>)}
                    </dd>
                  </div>)}
              </dl>
              <div className="border-l border-gold/20 pl-6 text-sm sm:max-w-[11rem]" data-id="element-57" data-mp="2nuxm6td8dnq5">
                <p className="font-display uppercase tracking-[0.14em] text-gold" data-id="element-58" data-mp="3bkrvj0yccu5n">Affilié FFKaraté</p>
                <p className="mt-2 text-xs leading-relaxed text-muted" data-id="element-59" data-mp="3fkah7yxzl99j">
                  Enseignement certifié, enseignants diplômés d’État et licence fédérale incluse dans la cotisation.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="zk-rule mt-12" data-id="element-60" data-mp="1q5uihrtcf0nr" />

        <div className="mt-6 flex flex-col gap-4 text-xs text-muted sm:flex-row sm:items-center sm:justify-between" data-id="element-61" data-mp="1q4svcoz1ynpo">
          <ul className="flex flex-wrap gap-x-5 gap-y-2" data-id="element-62" data-mp="1v3du0jynozc0">
            {NAV.map(item => <li key={item.to} data-id="element-63" data-mp="1nk4oj1t9tks8">
                <Link className="zk-focus hover:text-gold" to={item.to} data-id="element-64" data-mp="1in4q9d2nxmbo">
                  {item.label}
                </Link>
              </li>)}
          </ul>
          <p data-id="element-65" data-mp="1wkjiepkaw87c">© 2026 Zanshin Karaté Club — Tous droits réservés · Mentions légales · Politique RGPD</p>
        </div>
      </div>
    </footer>;
}